<template>
    <el-dialog custom-class="mobile-fullscreen" :visible.sync="isVisible" width="80%" @close="handleClose()">
      <div class="pl-30 pr-30">
        <div class="row">
          <div class="col-lg-7 mb-30 mb-lg-0">
            <h4>Q80 Countertop Terminal</h4>
            <h6>Our flagship countertop payment device for the point of sale.</h6>
            <p>The Q80 is PAX's smallest desktop payment terminal, packed with all required payment industry certifications and delivering the highest levels of payment security and transactional protection.</p>
            <p>The Q80 offers multiple wireless connectivity options, so you can easily connect it via existing infrastructure in-store. The large bright colour touchscreen inter face delivers a great user experience. Supporting all possible payment options as Chip &amp; PIN, NFC contactless, magstripe and mobile wallets, Q80 empowers merchants to accept any form of modern consumer payment.</p>

            <div class="row mt-4">
              <div class="col-sm-6">
                <div class="modal-table">
                  <ul>
                    <li><span>PCI PTS 4.x, SRED</span><i class='uil uil-check'></i></li>
                    <li><span>Small Footprint</span><i class='uil uil-check'></i></li>
                    <li><span>Omni-Channel Payment</span><i class='uil uil-check'></i></li>
                  </ul>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="modal-table">
                  <ul>
                    <li><span>4G, 3G, WiFi, Bluetooth, Modem, Ethernet</span><i class='uil uil-check'></i></li>
                    <li><span>4-Inch Capacitive Touchscreen</span><i class='uil uil-check'></i></li>
                    <li><span>Optional Inbuilt Camera</span><i class='uil uil-check'></i></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 text-center">
            <figure class="figure mb-30 mt-15 d-block">
              <img src="@/assets/pos.png" alt="mastercard world" class="img-fluid" style="max-height: 300px;">
            </figure>
          </div>
        </div>
        <div class="row mt-20">
          <div class="col-lg-7">
            <div class="row align-items-center">
              <div class="col-12 col-lg-auto text-center text-lg-left mb-20 mb-lg-0">
                <label class="mr-10 d-block d-lg-inline-block" for="">Number of POS:</label>
                <el-input-number v-model="posQuantity"></el-input-number>
              </div>
              <div class="col-12 col-lg-auto text-center text-lg-left mb-20 mb-lg-0">
                <span>Price: <strong>EUR {{ posPrice }}</strong></span>
              </div>
            </div>
          </div>
          <div class="col-lg-5 text-center">
            <button class="btn" @click="activateOption()">Activate Now</button>
          </div>
        </div>
      </div>
    </el-dialog>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'pos-modal',
  computed: {
    ...mapFields({
      isVisible: 'ui.modals.PosModal.visible',
      posQuantity: 'posQuantity'
    }),
    posPrice() {
      return this.posQuantity * 25
    }
  },
  methods: {
    handleClose() {
      this.closeModal()
    },
    activateOption() {
      this.closeModal()
      this.$store.commit('updatePosField', true)
    },
    closeModal() {
      this.$store.commit('showHideModal', {
        modal: 'PosModal',
        show: false
      })
    }
  }
}
</script>
